import React from "react";
import { ThemeModeProvider } from "./contexts/ThemeModeContext";

export const Providers: React.FC<{ children: React.ReactNode }> = (props) => {
  return <ThemeModeProvider>{props.children}</ThemeModeProvider>;
};
